/* ------------------------
共通JS
---------------------------*/

/* ------------------------
ページ内リンク
スクロール自体は CSS（html の scroll-behavior と .anchor-target の scroll-margin-top）で行い、
ここでは sticky ヘッダーの実寸を --header-offset に反映する
---------------------------*/
(() => {
  const root = document.documentElement;

  const getStickyHeader = () => {
    const header = document.querySelector('.site-header');
    if (!header) return null;
    return header.closest('.shopify-section') || header;
  };

  const updateHeaderOffset = () => {
    const header = getStickyHeader();
    if (!header) return;

    const height = Math.round(header.getBoundingClientRect().height);
    if (height > 0) {
      root.style.setProperty('--header-offset', `${height}px`);
    }
  };

  const scrollToHash = (hash) => {
    if (!hash || hash === '#') return;

    let target = null;
    try {
      target = document.querySelector(hash);
    } catch (error) {
      return;
    }
    if (!target) return;

    updateHeaderOffset();
    target.scrollIntoView({ block: 'start' });
  };

  const init = () => {
    updateHeaderOffset();

    const header = getStickyHeader();
    if (header && 'ResizeObserver' in window) {
      new ResizeObserver(updateHeaderOffset).observe(header);
    } else {
      window.addEventListener('resize', updateHeaderOffset);
    }

    /* クリック直前に高さを測り直しておく（ドロワー開閉や折り返しで変わるため） */
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (link && link.hash) updateHeaderOffset();
    });

    /* 別ページから #アンカー付きで来た場合の着地補正 */
    if (window.location.hash) {
      window.addEventListener(
        'load',
        () => {
          scrollToHash(window.location.hash);
        },
        { once: true }
      );
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* ------------------------
ヘッダー検索
開閉は CSS（.site-header__search-toggle）で行い、
ここでは開いたときの入力欄フォーカス・Esc で閉じる・メニューとの排他だけを扱う
---------------------------*/
(() => {
  document.addEventListener('change', (event) => {
    const toggle = event.target;
    if (!(toggle instanceof HTMLInputElement)) return;

    const header = toggle.closest('.site-header');
    if (!header) return;

    if (toggle.matches('.site-header__search-toggle') && toggle.checked) {
      const drawerToggle = header.querySelector('.site-header__toggle');
      if (drawerToggle) drawerToggle.checked = false;

      const input = header.querySelector('.site-header__search-input');
      if (input) window.setTimeout(() => input.focus(), 50);
    }

    if (toggle.matches('.site-header__toggle') && toggle.checked) {
      const searchToggle = header.querySelector('.site-header__search-toggle');
      if (searchToggle) searchToggle.checked = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    const searchButton = event.target instanceof Element && event.target.closest('.site-header__search-button');
    if (searchButton && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      searchButton.click();
      return;
    }

    if (event.key !== 'Escape') return;

    document.querySelectorAll('.site-header__search-toggle:checked').forEach((toggle) => {
      toggle.checked = false;
      const button = toggle.closest('.site-header')?.querySelector('.site-header__search-button');
      if (button) button.focus();
    });
  });
})();

/* ------------------------
アコーディオン（details.js-accordion）
interpolate-size 対応ブラウザは CSS だけで開閉アニメーションするため、
未対応ブラウザ（Safari / Firefox）のみ details の高さを JS でアニメーションする
---------------------------*/
(() => {
  if (window.CSS && CSS.supports('interpolate-size', 'allow-keywords')) return;

  const CLOSING_CLASS = 'is-closing';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getTiming = () => {
    const styles = getComputedStyle(document.documentElement);
    return {
      duration: parseFloat(styles.getPropertyValue('--accordion-duration')) * 1000 || 600,
      easing: styles.getPropertyValue('--ease-smooth').trim() || 'ease-out',
    };
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('details.js-accordion > summary');
    if (!summary || reducedMotion.matches) return;

    event.preventDefault();
    const details = summary.parentElement;
    const isClosing = details.open && !details.classList.contains(CLOSING_CLASS);

    /* アニメーション途中で再クリックされても、今の高さから折り返す */
    const startHeight = details.offsetHeight;
    details.getAnimations().forEach((animation) => animation.cancel());

    let endHeight;
    if (isClosing) {
      details.classList.add(CLOSING_CLASS);
      endHeight = summary.offsetHeight;
    } else {
      details.classList.remove(CLOSING_CLASS);
      details.open = true;
      endHeight = details.offsetHeight;
    }

    const animation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      getTiming()
    );

    if (isClosing) {
      animation.onfinish = () => {
        details.open = false;
        details.classList.remove(CLOSING_CLASS);
      };
    }
  });
})();
